import React, { useState, useEffect } from 'react';
import presetApi from '@services/presetApi.jsx';
import ResourceUploadField from '@components/common/ResourceUploadField.jsx';

const PresetPostCaptureLoadingSetting = ({ preset }) => {
    const [isLoading, setIsLoading] = useState(false);

    const searchParams = new URLSearchParams(location.search);
    const presetId = searchParams.get('presetId');
    const [presetPostCaptureLoadingPage, setPresetPostCaptureLoadingPage] = useState(null);

    // 폼 데이터 상태
    const [formData, setFormData] = useState({
        loadingVideoResourceId: null,
        isActive: true
    });

    // 페이지 데이터 로드
    useEffect(() => {
        loadPostCaptureLoadingPageData();
    }, [presetId]);

    // 촬영 후 로딩 페이지 데이터 로드
    const loadPostCaptureLoadingPageData = async () => {
        try {
            setIsLoading(true);
            const postCaptureLoadingPage = await presetApi.getPostCaptureLoadingPage(presetId);
            
            setPresetPostCaptureLoadingPage(postCaptureLoadingPage);
            
            setFormData({
                loadingVideoResourceId: postCaptureLoadingPage.loadingVideoResourceId ?? null,
                isActive: postCaptureLoadingPage.isActive ?? true
            });
        } catch (error) {
            console.error('촬영 후 로딩 페이지 데이터 로드 실패:', error);
            // 에러 시 기본값 유지
        } finally {
            setIsLoading(false);
        }
    };

    // 로딩 동영상 리소스 업로드 핸들러
    const handleLoadingVideoResourceUploaded = (resourceId) => {
        setFormData({
            ...formData,
            loadingVideoResourceId: resourceId
        });
    };

    // 저장 이벤트 리스너
    useEffect(() => {
        const eventName = `savePagePreset_shooting_loading`;

        const saveHandler = async (event) => {
            if (!preset?.id) {
                alert("프리셋 정보가 없습니다.");
                return;
            }

            try {
                setIsLoading(true);

                const dataToSave = {
                    presetId: event.detail.presetId,
                    loadingVideoResourceId: formData.loadingVideoResourceId,
                    isActive: formData.isActive
                };
                
                const response = await presetApi.savePostCaptureLoadingPage(event.detail.presetId, dataToSave);
                console.log("촬영 후 로딩 페이지 저장 성공:", response);

                // 저장 후 최신 데이터로 화면 갱신
                if (response) {
                    setFormData(response);
                    setPresetPostCaptureLoadingPage(response);
                }

            } catch (error) {
                console.error("촬영 후 로딩 페이지 저장 실패:", error);
                alert("촬영 후 로딩 페이지 저장 중 오류가 발생했습니다.");
            } finally {
                setIsLoading(false);
            }
        };

        document.addEventListener(eventName, saveHandler);

        return () => {
            document.removeEventListener(eventName, saveHandler);
        };
    }, [preset?.id, formData]);

    if (isLoading) {
        return <div className="preset-settings">로딩 중...</div>;
    }

    return (
        <div className="preset-settings">
            {/* 로딩 동영상 섹션 */}
            <div className="settings-box">
                <h4 className="settings-title">로딩 동영상</h4>
                <ResourceUploadField 
                    resourceId={formData.loadingVideoResourceId}
                    onResourceUploaded={handleLoadingVideoResourceUploaded}
                    acceptTypes="video/*"
                />
            </div>
        </div>
    );
};

export default PresetPostCaptureLoadingSetting;
